import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

type Report = {
  code: 'STUDENTS' | 'USER_DETAILS' | 'COURSES' | 'LEARNING_HOURS';
  filters?: {
    activityStatus?: 'active' | 'inactive';
    dateField?: 'updated_at' | 'followed_at';
    licenseType?: 'SPARK' | 'PIVOT' | 'BOOST' | 'UPLIFT';
  };
  groupBy: string[];
};

type GetAnalyticsParams = {
  reports: Report[];
  id: string;
  asCsv?: boolean;
  withHeaders?: boolean;
};

const { useGet: useOrganizationAnalytics } = getCRUDHooks({
  entityName: 'organizationAnalytics',
  async get({ reports, id, asCsv = false, withHeaders = false }: GetAnalyticsParams) {
    const response = await clientApi
      .getOCClient()
      .helpers.employer.organizations.id(id)
      .analytics.find({ reports, asCsv });

    return withHeaders ? { body: response } : response;
  },
});

export {
  // eslint-disable-next-line import/prefer-default-export
  useOrganizationAnalytics,
};
